import React from 'react';
import {Button} from '@betareader/design-system';
import {withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {push} from '../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {setCurrentConversation, clearCurrentConversation} from '../../modules/message';

export const MessageListMenu = ({
  backButton,
  newMessageButton,
  currentConversation,
  clearCurrentConversation,
  setCurrentConversation,
  changePage,
  t,
}) => {
  const onStartNewMessage = () => {
    if ((currentConversation && !currentConversation.isNew) || !currentConversation) {
      clearCurrentConversation();
      changePage('/inbox/conversations/new');
    }
  };

  const onBackToInbox = () => {
    changePage('/inbox/');
    setCurrentConversation(undefined);
  };

  return (
    <nav aria-label={t('Chat')} style={{display: 'flex', gap: '0.5rem'}}>
      {backButton && (
        <Button variant='ghost' aria-label={t('Back')} onClick={onBackToInbox}>
          <span aria-hidden='true'>‹ </span>{t('Back')}
        </Button>
      )}
      {newMessageButton && (
        <Button variant='ghost' onClick={onStartNewMessage}>
          <span aria-hidden='true'>✎ </span>{t('New')}
        </Button>
      )}
    </nav>
  );
};

const mapStateToProps = state => ({
  currentConversation: state.message.currentConversation,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  clearCurrentConversation,
  setCurrentConversation,
  changePage: newPage => push(newPage),
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageListMenu)));
